import { render, staticRenderFns } from "./ClosedMerchantCategoryList.vue?vue&type=template&id=392ce58c"
import script from "./ClosedMerchantCategoryList.vue?vue&type=script&lang=js"
export * from "./ClosedMerchantCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports